import { createSlice } from "@reduxjs/toolkit";

export const EMAIL_LOOP = "emailLoop";

const emailLoopSlice = createSlice({
    name: EMAIL_LOOP,
    initialState: {
        isLoading: false,
        emailLoopList: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setEmailLoopList(state, action) {
            state.emailLoopList = action.payload;
        },
    },
});

export const { setIsLoading, setEmailLoopList } = emailLoopSlice.actions;
export default emailLoopSlice.reducer;